import tmhRequest from '@/config/tmhRequest'

export default {
    sendTextMessage: function (data) {
        return tmhRequest({
            url: '/common/tmh/aliyun/sendtextmessage',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/common/aliyun.js